import { Box } from '@chakra-ui/react'
import AdminLayout from '../components/AdminLayout'
import LineGraphs from './admin/LineGraphs'
import ModuleButtons from './admin/Modules'
import StatsCounters from './admin/StatsCounters'

const AdminPage = () => {
  return (
    <AdminLayout>
      <Box p={{ base: 4, md: 6 }}>
        {/* Grid de Contadores */}
        <StatsCounters selectedEvent="" />

        {/* Gráfico de Linha */}
        <LineGraphs />

        {/* Botões dos Módulos */}
        <ModuleButtons />
      </Box>
    </AdminLayout>
  );
};

export default AdminPage;
